<template>
  <section class="delivery-app-section pt-4 pb-4 pt-lg-5 pb-lg-5 position-relative overflow-hidden" id="delivery">
    <div class="container-fluid delivery-container position-relative z-1">
      
      <!-- Fila 1: Smartphone + Beneficios de Pedidos + Plataformas -->
      <div class="row align-items-center g-4 g-xl-5 mb-4 mb-lg-5">
        
        <!-- Columna Izquierda: Celular Mockup Realista con Presencia Amplia -->
        <div class="col-12 col-lg-5 text-center">
          <div class="phone-showcase-wrapper position-relative d-inline-block mx-auto">
            <!-- Resplandor ambiental de fondo -->
            <div class="fresh-circle-glow"></div>

            <!-- Mockup iPhone Realista con la App The Fit Bar -->
            <div class="phone-device-real position-relative z-1">
              <img
                :src="require('@/assets/img/phone_mockup_fitbar.png')"
                alt="The Fit Bar App Móvil - Menú Digital"
                class="img-fluid phone-mockup-img"
              />
            </div>
          </div>
        </div>

        <!-- Columna Derecha: Texto, Píldoras de Valor, Botón y Plataformas -->
        <div class="col-12 col-lg-7 text-center text-lg-start">
          
          <h2 class="roboto fw-bold text-white mb-3 delivery-title">
            Tu Comida Saludable <span class="text-naranja">Donde Estés</span>
          </h2>

          <p class="quicksand lead text-white mb-4 delivery-lead">
            Disfruta de tus platillos y batidos favoritos como más te convenga: 
            <strong class="text-muted">ordena directamente desde la aplicación The Fit Gym</strong> para tener tu comida lista al terminar tu entrenamiento, 
            o búscanos en tus <strong class="text-muted">plataformas de comida favoritas</strong> con empaque hermético directo a tu casa u oficina.
          </p>

     

          <!-- Botón Principal WhatsApp -->
          <div class="mb-4">
            <a
              href="https://api.whatsapp.com/send?phone=9983641651&text=%C2%A1Hola%20The%20Fit%20Bar!%20%F0%9F%8D%BD%EF%B8%8F%20Quiero%20hacer%20un%20pedido%20a%20domicilio."
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-delivery-whatsapp d-inline-flex align-items-center gap-2"
            >
              <i class="bi bi-whatsapp fs-5"></i>
              <span>PEDIR POR WHATSAPP</span>
            </a>
          </div>

          <!-- Plataformas habituales de Delivery -->
          <div class="platforms-bar pt-3 border-top border-light-subtle">
            <span class="d-block small text-muted fw-bold mb-3 text-uppercase" style="letter-spacing: 0.8px;">
              O pídelo en tus plataformas de comida favoritas:
            </span>
            <div class="platforms-app-container d-flex flex-wrap align-items-center gap-3 gap-md-4 justify-content-center justify-content-lg-start">
              
              <!-- 1. WhatsApp -->
              <a
                href="https://api.whatsapp.com/send?phone=9983641651&text=%C2%A1Hola%20The%20Fit%20Bar!%20%F0%9F%8D%BD%EF%B8%8F%20Quiero%20hacer%20un%20pedido%20a%20domicilio."
                target="_blank"
                rel="noopener noreferrer"
                class="platform-app-badge platform-badge-wa"
                title="Pedir por WhatsApp"
              >
                <img
                  :src="require('@/assets/img/whatsaap.png')"
                  alt="WhatsApp The Fit Bar"
                  class="platform-app-img"
                />
              </a>

              <!-- 2. Uber Eats -->
              <a
                href="https://www.ubereats.com/mx/store/the-fit-bar-av-cancun/X8c50DMZSaCOWv9K5BY8ZA?diningMode=DELIVERY&sc=SEARCH_SUGGESTION"
                target="_blank"
                rel="noopener noreferrer"
                class="platform-app-badge platform-badge-uber"
                title="Pedir por Uber Eats"
              >
                <img
                  :src="require('@/assets/img/logo_uber_eats.png')"
                  alt="Uber Eats The Fit Bar"
                  class="platform-app-img"
                />
              </a>

              <!-- 3. Rappi -->
              <a
                href="https://www.rappi.com.mx"
                target="_blank"
                rel="noopener noreferrer"
                class="platform-app-badge platform-badge-rappi"
                title="Pedir por Rappi"
              >
                <img
                  :src="require('@/assets/img/logo_rappi.png')"
                  alt="Rappi The Fit Bar"
                  class="platform-app-img"
                />
              </a>

              <!-- 4. DiDi Food -->
              <a
                href="https://www.didiglobal.com"
                target="_blank"
                rel="noopener noreferrer"
                class="platform-app-badge platform-badge-didi"
                title="Pedir por DiDi Food"
              >
                <img
                  :src="require('@/assets/img/logo_didi_food.png')"
                  alt="DiDi Food The Fit Bar"
                  class="platform-app-img"
                />
              </a>

            </div>
          </div>
        </div>

      </div>

      <!-- Fila 2: Showcase de Empaques Herméticos Meal Prep (Aprovechamiento total del ancho) -->
      <div class="text-center mb-4 mb-lg-5">
        <h3 class="roboto fw-bold text-white fs-1 mb-2">
          Listos para Llevar a tu <span class="text-naranja">Oficina o Gym</span>
        </h3>
        <p class="quicksand text-muted mx-auto mb-0" style="max-width: 680px; font-size: 1.02rem;">
          Sellados de grado alimenticio que mantienen la temperatura, frescura y textura de tus macronutrientes intactos hasta el último bocado.
        </p>
      </div>

        <div class="row row-cols-2 row-cols-sm-3 row-cols-lg-5 g-3 g-xl-4 justify-content-center align-items-stretch">
          <!-- 1. Pechuga & Camote -->
          <div class="col">
            <div class="mealprep-card-box h-100 d-flex flex-column align-items-center justify-content-between p-3 rounded-4">
              <img :src="require('@/assets/img/NEW Delivery_1.png')" alt="Pechuga & Camote" class="mealprep-bowl-img" />
              <div class="mt-2 text-center w-100">
                <span class="mealprep-caption">Pechuga & Camote</span>
              </div>
            </div>
          </div>

          <!-- 2. Hot Cakes & Frutas -->
          <div class="col">
            <div class="mealprep-card-box h-100 d-flex flex-column align-items-center justify-content-between p-3 rounded-4">
              <img :src="require('@/assets/img/NEW Delivery_2.png')" alt="Hot Cakes & Frutas" class="mealprep-bowl-img" />
              <div class="mt-2 text-center w-100">
                <span class="mealprep-caption">Hot Cakes & Frutas</span>
              </div>
            </div>
          </div>

          <!-- 3. Sirloin & Puré -->
          <div class="col">
            <div class="mealprep-card-box h-100 d-flex flex-column align-items-center justify-content-between p-3 rounded-4">
              <img :src="require('@/assets/img/NEW Delivery_1.png')" alt="Sirloin & Puré" class="mealprep-bowl-img" />
              <div class="mt-2 text-center w-100">
                <span class="mealprep-caption">Sirloin & Puré</span>
              </div>
            </div>
          </div>

          <!-- 4. Avena Imperial -->
          <div class="col">
            <div class="mealprep-card-box h-100 d-flex flex-column align-items-center justify-content-between p-3 rounded-4">
              <img :src="require('@/assets/img/NEW Delivery_2.png')" alt="Avena Imperial" class="mealprep-bowl-img" />
              <div class="mt-2 text-center w-100">
                <span class="mealprep-caption">Avena Imperial</span>
              </div>
            </div>
          </div>

          <!-- 5. Salmón Fit -->
          <div class="col">
            <div class="mealprep-card-box h-100 d-flex flex-column align-items-center justify-content-between p-3 rounded-4">
              <img :src="require('@/assets/img/NEW Delivery_1.png')" alt="Salmón Fit" class="mealprep-bowl-img" />
              <div class="mt-2 text-center w-100">
                <span class="mealprep-caption">Salmón Fit</span>
              </div>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Delivery",
};
</script>

<style scoped>
.delivery-app-section {
  background-color: #0b0b0b;
}

.text-naranja {
  color: #fd6f3c !important;
}

.delivery-overline {
  background: #fff3ee;
  border: 1px solid rgba(253, 111, 60, 0.25);
  color: #fd6f3c;
  padding: 4px 16px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.8px;
}

.delivery-container {
  max-width: 1440px;
  margin: 0 auto;
  padding-left: clamp(1rem, 3.5vw, 3.5rem);
  padding-right: clamp(1rem, 3.5vw, 3.5rem);
}

.delivery-title {
  font-size: clamp(2rem, 3vw, 2.85rem);
  line-height: 1.15;
}

.delivery-lead {
  font-size: 1.10rem;
  line-height: 1.6;
  max-width: 640px;
}

.delivery-perks-grid {
  margin-top: 0.5rem;
}

.delivery-perk-item {
  background: #f8fafb;
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: 8px 16px;
  border-radius: 50px;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.82rem;
  font-weight: 700;
  color: #2b2b2b;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}

/* Smartphone Mockup Realista (Captura 2) - Tamaño ampliado que domina el espacio */
.phone-showcase-wrapper {
  max-width: 440px;
  position: relative;
}

.fresh-circle-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 95%;
  height: 95%;
  background: radial-gradient(circle, rgba(253, 111, 60, 0.18) 0%, rgba(253, 111, 60, 0.05) 50%, rgba(255, 255, 255, 0) 75%);
  border-radius: 50%;
  z-index: 0;
  filter: blur(28px);
}

.phone-device-real {
  position: relative;
  z-index: 1;
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.phone-device-real:hover {
  transform: translateY(-8px) scale(1.02);
}

.phone-mockup-img {
  width: 63%;
  max-width: 410px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 25px 50px rgba(0, 0, 0, 0.28)) drop-shadow(0 10px 24px rgba(253, 111, 60, 0.15));
}

@media (max-width: 991px) {
  .phone-mockup-img {
    max-width: 330px;
  }
}

/* Badge Flotante App The Fit Gym */
.floating-app-badge {
  position: absolute;
  top: 35px;
  right: -10px;
  z-index: 3;
  background: rgba(18, 22, 24, 0.92);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(253, 111, 60, 0.45);
  color: #ffffff;
  padding: 6px 14px;
  border-radius: 50px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);
  animation: floatAppBadge 4.5s ease-in-out infinite alternate;
}

.pulse-app-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #25d366;
  box-shadow: 0 0 10px #25d366;
  display: inline-block;
}

.badge-app-text {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.4px;
}

@keyframes floatAppBadge {
  0% { transform: translateY(0); }
  100% { transform: translateY(-8px); }
}

/* Métricas */
.metric-number {
  font-size: 2.2rem;
  line-height: 1;
}

.btn-delivery-whatsapp {
  background-color: #25d366;
  color: #ffffff;
  font-weight: 800;
  font-size: 1rem;
  padding: 14px 32px;
  border-radius: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-delivery-whatsapp:hover {
  background-color: #1eb956;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(37, 211, 102, 0.45);
}

/* Plataformas de Delivery - Iconos Grandes estilo App (Captura 1) */
.platforms-app-container {
  padding: 8px 0;
}

.platform-app-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 10rem;
  height: 10rem;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4);
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.35s ease;
  flex-shrink: 0;
  text-decoration: none;
}

.platform-badge-wa {
  animation: floatAppIcon 4.5s ease-in-out infinite alternate;
}

.platform-badge-uber {
  animation: floatAppIcon 4.8s ease-in-out 0.3s infinite alternate;
}

.platform-badge-rappi {
  animation: floatAppIcon 5.1s ease-in-out 0.6s infinite alternate;
}

.platform-badge-didi {
  animation: floatAppIcon 4.6s ease-in-out 0.9s infinite alternate;
}

@keyframes floatAppIcon {
  0% { transform: translateY(0px); }
  100% { transform: translateY(-6px); }
}

.platform-app-badge:hover {
  animation-play-state: paused;
  transform: translateY(-10px) scale(1.1) !important;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.65) !important;
}

.platform-app-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@media (max-width: 575px) {
  .platform-app-badge {
    width: 66px;
    height: 66px;
    border-radius: 16px;
  }
}

.badge-mini-bowl {
  width: 44px;
  height: 44px;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
}


.mealprep-badge {
  background: rgba(253, 111, 60, 0.15);
  border: 1px solid rgba(253, 111, 60, 0.35);
  color: #fd6f3c;
  padding: 4px 14px;
  border-radius: 50px;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.8px;
}

/* Showcase Shelf de Empaques Herméticos (Aprovechamiento total de ancho) */
.mealprep-shelf-card {
  background: linear-gradient(180deg, #fafbfc 0%, #f2f5f7 100%);
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.04);
}

.badge-shelf-overline {
  background: #fff3ee;
  border: 1px solid rgba(253, 111, 60, 0.35);
  color: #fd6f3c;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 1px;
  padding: 4px 14px;
  border-radius: 50px;
}

.mealprep-card-box {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: pointer;
}

.mealprep-card-box:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.1);
  border-color: rgba(253, 111, 60, 0.35);
}

.mealprep-bowl-img {
  width: 170px;
  height: 170px;
  object-fit: contain;
  filter: drop-shadow(0 14px 22px rgba(0, 0, 0, 0.14));
  transition: transform 0.35s ease;
}

.mealprep-card-box:hover .mealprep-bowl-img {
  transform: scale(1.08) rotate(-2deg);
}

.mealprep-caption {
  display: block;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.88rem;
  font-weight: 800;
  color: #1a1a1a;
  white-space: nowrap;
}

.mealprep-micro-tag {
  display: inline-block;
  font-family: 'Quicksand', sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  color: #fd6f3c;
  background: #fff3ee;
  padding: 2px 10px;
  border-radius: 20px;
  margin-top: 4px;
}

@media (max-width: 991px) {
  .delivery-title {
    font-size: 2rem;
  }
  .mealprep-bowl-img {
    width: 130px;
    height: 130px;
  }
  .mealprep-caption {
    font-size: 0.8rem;
  }
}
</style>
